import React, { useState, useEffect } from 'react';
// Excel export için utils import ekleyelim
import * as XLSX from 'xlsx';

const API_BASE = process.env.REACT_APP_API_URL || '/it/api';

const getFullNameByEmail = (email, users) => {
  if (!email || !users) return 'Bilinmiyor';
  const user = users.find(u => u.email === email);
  if (!user) return email;
  return user.first_name && user.last_name 
    ? `${user.first_name} ${user.last_name}` 
    : user.full_name || email;
};

const AdminInventory = ({ users }) => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [viewingItem, setViewingItem] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showInlineCategoryForm, setShowInlineCategoryForm] = useState(false);
  const [filterCategory, setFilterCategory] = useState('');
  const [filterUser, setFilterUser] = useState('');
  const [filterStatus, setFilterStatus] = useState(''); // Yeni durum filtresi
  const [searchProductCode, setSearchProductCode] = useState('');
  const [sortBy, setSortBy] = useState('product_name'); // Yeni sıralama
  const [sortOrder, setSortOrder] = useState('asc'); // Yeni sıralama yönü
  const [newItem, setNewItem] = useState({
    product_name: '',
    brand: '',
    model: '',
    serial_code: '',
    product_code: '',
    assigned_user_email: '',
    category_id: '',
    location: '',
    notes: '',
    computer_specs: '',
    purchase_date: '',
    warranty_end_date: ''
  });
  const [newCategory, setNewCategory] = useState({
    name: '',
    description: ''
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchInventory();
    fetchCategories();
  }, []);

  // Envanter listesini getir
  const fetchInventory = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/admin/inventory`, {
        headers:{ 
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setInventory(data);
      } else {
        setMessage('Envanter listesi yüklenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Kategorileri getir
  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_BASE}/admin/categories`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setCategories(data);
      }
    } catch (error) {
      console.error('Kategoriler yüklenirken hata:', error);
    }
  };

  // Ürün ekleme
  const handleAddItem = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE}/admin/inventory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          ...newItem,
          category_id: newItem.category_id || null
        })
      });

      if (response.ok) {
        setMessage('Ürün başarıyla eklendi!');
        setNewItem({
          product_name: '',
          brand: '',
          model: '',
          serial_code: '',
          product_code: '',
          assigned_user_email: '',
          category_id: '',
          location: '',
          notes: '',
          purchase_date: '',
          warranty_end_date: ''
        });
        setShowAddForm(false);
        await fetchInventory();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const errorData = await response.json();
        setMessage(errorData.error || 'Ürün eklenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası: ' + error.message);
    }
  };

  // Ürün güncelleme
  const handleUpdateItem = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE}/admin/inventory/${editingItem.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          ...editingItem,
          category_id: editingItem.category_id || null
        })
      });

      if (response.ok) {
        setMessage('Ürün başarıyla güncellendi!');
        setEditingItem(null);
        setViewingItem(null);
        await fetchInventory();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const errorData = await response.json();
        setMessage(errorData.error || 'Ürün güncellenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası: ' + error.message);
    }
  };

  // Ürün silme
  const handleDeleteItem = async (itemId) => {
    if (window.confirm('Bu ürünü silmek istediğinizden emin misiniz?')) {
      try {
        const response = await fetch(`${API_BASE}/admin/inventory/${itemId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.ok) {
          setMessage('Ürün başarıyla silindi!');
          setViewingItem(null);
          setEditingItem(null);
          await fetchInventory();
          setTimeout(() => setMessage(''), 3000);
        } else {
          const errorData = await response.json();
          setMessage(errorData.error || 'Ürün silinirken hata oluştu!');
        }
      } catch (error) {
        setMessage('Bağlantı hatası: ' + error.message);
      }
    }
  };

  // Inline kategori ekleme
  const handleAddInlineCategory = async () => {
    if (!newCategory.name.trim()) {
      setMessage('Kategori adı boş olamaz!');
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/admin/categories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(newCategory)
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Kategori başarıyla eklendi!');
        setNewCategory({ name: '', description: '' });
        setShowInlineCategoryForm(false);
        await fetchCategories();
        
        const categoryId = data.categoryId || data.id || data.insertId;
        if (categoryId) {
          setNewItem({...newItem, category_id: categoryId.toString()});
        }
        
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.error || 'Kategori eklenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası: ' + error.message);
    }
  };

  // Durum etiketleri - scrap -> stock
  const getStatusLabel = (status) => {
    const labels = {
      active: 'Aktif',
      assigned: 'Atanmış',
      maintenance: 'Bakımda',
      broken: 'Arızalı',
      stock: 'Stokta' // scrap yerine stock
    };
    return labels[status] || 'Aktif';
  };

  // Tarih formatlama
  const formatDate = (dateString) => {
    if (!dateString) return 'Belirtilmemiş';
    return new Date(dateString).toLocaleDateString('tr-TR');
  };

  // Kullanıcıları isim sırasına göre sıralayan fonksiyon
  const getSortedUsers = () => {
    return users
      .filter(u => u.role === 'user')
      .sort((a, b) => {
        const nameA = getFullNameByEmail(a.email, users).toLowerCase();
        const nameB = getFullNameByEmail(b.email, users).toLowerCase();
        return nameA.localeCompare(nameB, 'tr-TR');
      });
  };

  // Filtrelenmiş ve sıralanmış envanteri hesapla
  const filteredAndSortedInventory = inventory
    .filter(item => {
      const categoryMatch = !filterCategory || String(item.category_id) === String(filterCategory);
      const userMatch = !filterUser || item.assigned_user_email === filterUser;
      const statusMatch = !filterStatus || (item.status || 'active') === filterStatus; // Durum filtresi
      const productCodeMatch = !searchProductCode || (item.product_code && item.product_code.toLowerCase().includes(searchProductCode.toLowerCase()));
      return categoryMatch && userMatch && statusMatch && productCodeMatch;
    })
    .sort((a, b) => {
      let aValue, bValue;
      
      if (sortBy === 'product_name') {
        aValue = (a.product_name || '').toLowerCase();
        bValue = (b.product_name || '').toLowerCase();
      } else if (sortBy === 'product_code') {
        aValue = (a.product_code || '').toLowerCase();
        bValue = (b.product_code || '').toLowerCase();
      } else if (sortBy === 'category') {
        aValue = (a.category_name || 'zzz').toLowerCase();
        bValue = (b.category_name || 'zzz').toLowerCase();
      } else if (sortBy === 'status') {
        aValue = getStatusLabel(a.status || 'active').toLowerCase();
        bValue = getStatusLabel(b.status || 'active').toLowerCase();
      }
      
      if (sortOrder === 'asc') {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });

  // Excel export fonksiyonu
  const exportToExcel = () => {
    try {
      // Filtrelenmiş ve sıralanmış envanteri al
      const dataToExport = filteredAndSortedInventory.map((item, index) => ({
        'Sıra No': index + 1,
        'Ürün Adı': item.product_name || '',
        'Marka': item.brand || '',
        'Model': item.model || '',
        'Seri No': item.serial_code || '',
        'Ürün Kodu': item.product_code || '',
        'Kategori': item.category_name || 'Belirtilmemiş',
        'Atanan Kullanıcı': getFullNameByEmail(item.assigned_user_email, users) || 'Atanmadı',
        'Kullanıcı Email': item.assigned_user_email || '',
        'Lokasyon': item.location || 'Belirtilmemiş',
        'Durum': getStatusLabel(item.status),
        'Alış Tarihi': item.purchase_date ? formatDate(item.purchase_date) : 'Belirtilmemiş',
        'Garanti Bitiş': item.warranty_end_date ? formatDate(item.warranty_end_date) : 'Belirtilmemiş',
        'Eklenme Tarihi': formatDate(item.created_at),
        'Atanma Tarihi': item.assignment_date ? formatDate(item.assignment_date) : '',
        'Bilgisayar Özellikleri': item.computer_specs || '',
        'Notlar': item.notes || ''
      }));

      if (dataToExport.length === 0) {
        setMessage('Dışa aktarılacak veri bulunamadı!');
        setTimeout(() => setMessage(''), 3000);
        return;
      }

      // Worksheet oluştur
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      
      // Sütun genişliklerini ayarla
      const columnWidths = [
        { wch: 8 },   // Sıra No
        { wch: 25 },  // Ürün Adı
        { wch: 15 },  // Marka
        { wch: 15 },  // Model
        { wch: 20 },  // Seri No
        { wch: 15 },  // Ürün Kodu
        { wch: 15 },  // Kategori
        { wch: 20 },  // Atanan Kullanıcı
        { wch: 25 },  // Kullanıcı Email
        { wch: 15 },  // Lokasyon
        { wch: 12 },  // Durum
        { wch: 12 },  // Alış Tarihi
        { wch: 12 },  // Garanti Bitiş
        { wch: 12 },  // Eklenme Tarihi
        { wch: 12 },  // Atanma Tarihi
        { wch: 30 }   // Notlar
      ];
      ws['!cols'] = columnWidths;

      // Workbook oluştur
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Envanter');

      // Dosya adı oluştur (tarih ve filtrelere göre)
      const now = new Date();
      const dateStr = now.toISOString().split('T')[0];
      let fileName = `Envanter_${dateStr}`;
      
      // Aktif filtreleri dosya adına ekle
      const activeFilters = [];
      if (filterCategory) {
        const categoryName = categories.find(c => c.id.toString() === filterCategory)?.name;
        if (categoryName) activeFilters.push(categoryName);
      }
      if (filterUser) {
        const userName = getFullNameByEmail(filterUser, users);
        if (userName !== filterUser) activeFilters.push(userName);
      }
      if (filterStatus) {
        activeFilters.push(getStatusLabel(filterStatus));
      }
      if (searchProductCode) {
        activeFilters.push(`Arama_${searchProductCode}`);
      }
      
      if (activeFilters.length > 0) {
        fileName += `_${activeFilters.join('_').replace(/[^\w\s-]/g, '')}`;
      }
      
      fileName += '.xlsx';

      // Dosyayı indir
      XLSX.writeFile(wb, fileName);
      
      // Başarı mesajı
      setMessage(`Excel dosyası başarıyla indirildi: ${fileName}`);
      setTimeout(() => setMessage(''), 5000);

    } catch (error) {
      console.error('Excel export hatası:', error);
      setMessage('Excel dosyası oluşturulurken hata oluştu!');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading">Envanter yükleniyor...</div>
      </div>
    );
  }

  const safeInventory = Array.isArray(filteredAndSortedInventory) ? filteredAndSortedInventory : [];

  return (
    <div className="admin-inventory-container">
      <div className="admin-inventory-header">
        <h3>Envanter ({inventory.length})</h3>
        <button 
          onClick={() => setShowAddForm(!showAddForm)}
          className="inventory-btn-primary"
        >
          + Ürün Ekle
        </button>
      </div>

      {/* Filtreleme ve Sıralama Alanı */}
      <div className="admin-inventory-filters">
        <div className="filter-row">
          {/* Sol taraf - Filtreler Grid */}
          <div className="filter-group">
            <div className="filter-grid">
              <div className="filter-grid-row">
                <input
                  type="text"
                  className="inventory-search-input"
                  placeholder="Ürün kodu ile ara..."
                  value={searchProductCode}
                  onChange={e => setSearchProductCode(e.target.value)}
                />
                <select
                  value={filterCategory}
                  onChange={e => setFilterCategory(e.target.value)}
                  className="inventory-filter-select"
                >
                  <option value="">Tüm Kategoriler</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>{category.name}</option>
                  ))}
                </select>
              </div>
              
              <div className="filter-grid-row">
                <select
                  value={filterUser}
                  onChange={e => setFilterUser(e.target.value)}
                  className="inventory-filter-select"
                >
                  <option value="">Tüm Kullanıcılar</option>
                  {getSortedUsers().map(user => (
                    <option key={user.id} value={user.email}>
                      {getFullNameByEmail(user.email, users)}
                    </option>
                  ))}
                </select>
                <select
                  value={filterStatus}
                  onChange={e => setFilterStatus(e.target.value)}
                  className="inventory-filter-select"
                >
                  <option value="">Tüm Durumlar</option>
                  <option value="active">Aktif</option>
                  <option value="assigned">Atanmış</option>
                  <option value="maintenance">Bakımda</option>
                  <option value="broken">Arızalı</option>
                  <option value="stock">Stokta</option>
                </select>
              </div>
            </div>
          </div>
          
          {/* Sağ taraf - Sıralama ve Excel Export */}
          <div className="sort-group">
            <label className="sort-label">Sırala:</label>
            <select
              value={sortBy}
              onChange={e => setSortBy(e.target.value)}
              className="inventory-sort-select"
            >
              <option value="product_name">Ürün Adı</option>
              <option value="product_code">Ürün Kodu</option>
              <option value="category">Kategori</option>
              <option value="status">Durum</option>
            </select>
            <button
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className="inventory-sort-direction"
              title={`${sortOrder === 'asc' ? 'Artan' : 'Azalan'} sırada - Değiştir`}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
            <span className="inventory-filter-count">
              {safeInventory.length} ürün
            </span>
            
            {/* Excel Export Button */}
            <button
              onClick={exportToExcel}
              className="inventory-btn-excel-export"
              title="Filtrelenmiş verileri Excel'e aktar"
              disabled={safeInventory.length === 0}
            >
              📊 Excel
            </button>
          </div>
        </div>
      </div>

      {/* Add Item Modal */}
      {showAddForm && (
        <div className="inventory-modal-overlay" onClick={() => setShowAddForm(false)}>
          <div className="inventory-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="inventory-modal-header">
              <h4>Yeni Ürün Ekle</h4>
              <button 
                className="inventory-modal-close"
                onClick={() => setShowAddForm(false)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleAddItem}>
              <div className="inventory-modal-body">
                <div className="inventory-add-item-info">
                  <strong>Yeni ürün bilgilerini doldurun</strong>
                </div>
                
                {/* Ürün Bilgileri Grid */}
                <div className="inventory-details-grid">
                  {/* İlk 6 alan aynı kalacak */}
                  <div className="inventory-form-group">
                    <label>Ürün Adı</label>
                    <input
                      type="text"
                      placeholder="Ürün adı"
                      value={newItem.product_name}
                      onChange={(e) => setNewItem({...newItem, product_name: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Marka</label>
                    <input
                      type="text"
                      placeholder="Marka"
                      value={newItem.brand}
                      onChange={(e) => setNewItem({...newItem, brand: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Model</label>
                    <input
                      type="text"
                      placeholder="Model"
                      value={newItem.model}
                      onChange={(e) => setNewItem({...newItem, model: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Seri No</label>
                    <input
                      type="text"
                      placeholder="Seri numarası"
                      value={newItem.serial_code}
                      onChange={(e) => setNewItem({...newItem, serial_code: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Ürün Kodu</label>
                    <input
                      type="text"
                      placeholder="Ürün kodu"
                      value={newItem.product_code}
                      onChange={(e) => setNewItem({...newItem, product_code: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Kategori</label>
                    <div className="inventory-category-input-group">
                      <select
                        value={newItem.category_id}
                        onChange={(e) => setNewItem({...newItem, category_id: e.target.value})}
                      >
                        <option value="">Kategori seçin...</option>
                        {categories.map(category => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <button 
                        type="button"
                        onClick={() => setShowInlineCategoryForm(!showInlineCategoryForm)}
                        className="inventory-btn-add-category"
                        title="Yeni kategori ekle"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="inventory-form-group">
                    <label>Atanan Kullanıcı</label>
                    <select
                      value={newItem.assigned_user_email}
                      onChange={(e) => setNewItem({...newItem, assigned_user_email: e.target.value})}
                    >
                      <option value="">Kullanıcı seçin (isteğe bağlı)...</option>
                      {getSortedUsers().map(user => (
                        <option key={user.id} value={user.email}>
                          {getFullNameByEmail(user.email, users)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Diğer alanlar aynı kalacak */}
                  <div className="inventory-form-group">
                    <label>Lokasyon</label>
                    <input
                      type="text"
                      placeholder="Ofis 1, Depo, Saha vb."
                      value={newItem.location}
                      onChange={(e) => setNewItem({...newItem, location: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Alış Tarihi</label>
                    <input
                      type="date"
                      value={newItem.purchase_date}
                      onChange={(e) => setNewItem({...newItem, purchase_date: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Garanti Bitiş Tarihi</label>
                    <input
                      type="date"
                      value={newItem.warranty_end_date}
                      onChange={(e) => setNewItem({...newItem, warranty_end_date: e.target.value})}
                    />
                  </div>

                  {/* Bilgisayar Özellikleri - Full width */}
                  <div className="inventory-form-group inventory-form-full-width">
                    <label>Bilgisayar Özellikleri</label>
                    <textarea
                      placeholder="İşlemci, RAM, disk, ekran kartı vb."
                      value={newItem.computer_specs}
                      onChange={(e) => setNewItem({...newItem, computer_specs: e.target.value})}
                      rows="3"
                    />
                  </div>

                  {/* Notlar - Full width */}
                  <div className="inventory-form-group inventory-form-full-width">
                    <label>Notlar</label>
                    <textarea
                      placeholder="İsteğe bağlı notlar"
                      value={newItem.notes}
                      onChange={(e) => setNewItem({...newItem, notes: e.target.value})}
                      rows="3"
                    />
                  </div>
                </div>

                {/* Inline Category Form - aynı kalacak */}
                {showInlineCategoryForm && (
                  <div className="inventory-inline-category-form">
                    <div className="inventory-inline-form-group">
                      <input
                        type="text"
                        placeholder="Kategori adı"
                        value={newCategory.name}
                        onChange={(e) => setNewCategory({...newCategory, name: e.target.value})}
                      />
                      <div className="inventory-inline-form-actions">
                        <button 
                          type="button" 
                          onClick={handleAddInlineCategory}
                          className="inventory-btn-primary-sm"
                          disabled={!newCategory.name.trim()}
                        >
                          Ekle
                        </button>
                        <button 
                          type="button" 
                          onClick={() => setShowInlineCategoryForm(false)}
                          className="inventory-btn-secondary-sm"
                        >
                          İptal
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="inventory-modal-footer">
                <button type="submit" className="inventory-btn-primary">
                  Ürün Ekle
                </button>
                <button
                  type="button"
                  onClick={() => setShowAddForm(false)}
                  className="inventory-btn-secondary"
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Item Details Modal */}
      {viewingItem && (
        <div className="inventory-modal-overlay" onClick={() => setViewingItem(null)}>
          <div className="inventory-modal-content inventory-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="inventory-modal-header">
              <h4>Ürün Detayları</h4>
              <button 
                className="inventory-modal-close"
                onClick={() => setViewingItem(null)}
              >
                ✕
              </button>
            </div>
            
            <div className="inventory-modal-body">
              <div className="inventory-item-details-card">
                <div className="inventory-item-header">
                  <h4>{viewingItem.product_name}</h4>
                  <span className={`inventory-item-status inventory-status-${viewingItem.status || 'active'}`}>
                    {getStatusLabel(viewingItem.status)}
                  </span>
                </div>
                
                <div className="inventory-item-details">
                  <div className="inventory-details-grid">
                    <div className="inventory-detail-item">
                      <strong>Marka/Model:</strong>
                      <span>{viewingItem.brand} {viewingItem.model}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Seri No:</strong>
                      <span>{viewingItem.serial_code}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Ürün Kodu:</strong>
                      <span>{viewingItem.product_code}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Kategori:</strong>
                      <span>{viewingItem.category_name || 'Belirtilmemiş'}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Atanan Kullanıcı:</strong>
                      <span>{getFullNameByEmail(viewingItem.assigned_user_email, users) || 'Kimseye atanmadı'}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Lokasyon:</strong>
                      <span>{viewingItem.location || 'Belirtilmemiş'}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Alış Tarihi:</strong>
                      <span>{formatDate(viewingItem.purchase_date)}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Garanti Bitiş:</strong>
                      <span>{formatDate(viewingItem.warranty_end_date)}</span>
                    </div>
                    <div className="inventory-detail-item">
                      <strong>Eklenme Tarihi:</strong>
                      <span>{formatDate(viewingItem.created_at)}</span>
                    </div>
                    {viewingItem.assignment_date && (
                      <div className="inventory-detail-item">
                        <strong>Atanma Tarihi:</strong>
                        <span>{formatDate(viewingItem.assignment_date)}</span>
                      </div>
                    )}
                    {viewingItem.computer_specs && (
                      <div className="inventory-detail-item inventory-detail-full-width">
                        <strong>Bilgisayar Özellikleri:</strong>
                        <span>{viewingItem.computer_specs}</span>
                      </div>
                    )}
                    {viewingItem.notes && (
                      <div className="inventory-detail-item inventory-detail-full-width">
                        <strong>Notlar:</strong>
                        <span>{viewingItem.notes}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="inventory-modal-footer">
              <button 
                onClick={() => {
                  setEditingItem(viewingItem);
                  setViewingItem(null);
                }}
                className="inventory-btn-primary"
              >
                Düzenle
              </button>
              <button 
                onClick={() => handleDeleteItem(viewingItem.id)}
                className="inventory-btn-danger"
              >
                Sil
              </button>
              <button
                onClick={() => setViewingItem(null)}
                className="inventory-btn-secondary"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Item Modal */}
      {editingItem && (
        <div className="inventory-modal-overlay" onClick={() => setEditingItem(null)}>
          <div className="inventory-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="inventory-modal-header">
              <h4>Ürün Düzenle</h4>
              <button 
                className="inventory-modal-close"
                onClick={() => setEditingItem(null)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleUpdateItem}>
              <div className="inventory-modal-body">
                <div className="inventory-edit-item-info">
                  <strong>Düzenlenen Ürün:</strong> {editingItem.product_name}
                </div>
                
                {/* Ürün Bilgileri Grid */}
                <div className="inventory-details-grid">
                  {/* İlk 6 alan aynı kalacak */}
                  <div className="inventory-form-group">
                    <label>Ürün Adı</label>
                    <input
                      type="text"
                      value={editingItem.product_name}
                      onChange={(e) => setEditingItem({...editingItem, product_name: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Marka</label>
                    <input
                      type="text"
                      value={editingItem.brand || ''}
                      onChange={(e) => setEditingItem({...editingItem, brand: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Model</label>
                    <input
                      type="text"
                      value={editingItem.model || ''}
                      onChange={(e) => setEditingItem({...editingItem, model: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Seri No</label>
                    <input
                      type="text"
                      value={editingItem.serial_code}
                      onChange={(e) => setEditingItem({...editingItem, serial_code: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Ürün Kodu</label>
                    <input
                      type="text"
                      value={editingItem.product_code}
                      onChange={(e) => setEditingItem({...editingItem, product_code: e.target.value})}
                      required
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Kategori</label>
                    <select
                      value={editingItem.category_id || ''}
                      onChange={(e) => setEditingItem({...editingItem, category_id: e.target.value})}
                    >
                      <option value="">Kategori seçin...</option>
                      {categories.map(category => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="inventory-form-group">
                    <label>Atanan Kullanıcı</label>
                    <select
                      value={editingItem.assigned_user_email || ''}
                      onChange={(e) => setEditingItem({...editingItem, assigned_user_email: e.target.value})}
                    >
                      <option value="">Kullanıcı seçin...</option>
                      {getSortedUsers().map(user => (
                        <option key={user.id} value={user.email}>
                          {getFullNameByEmail(user.email, users)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Diğer alanlar aynı kalacak */}
                  <div className="inventory-form-group">
                    <label>Lokasyon</label>
                    <input
                      type="text"
                      value={editingItem.location || ''}
                      onChange={(e) => setEditingItem({...editingItem, location: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Durum</label>
                    <select
                      value={editingItem.status || 'active'}
                      onChange={(e) => setEditingItem({...editingItem, status: e.target.value})}
                    >
                      <option value="active">Aktif</option>
                      <option value="assigned">Atanmış</option>
                      <option value="maintenance">Bakımda</option>
                      <option value="broken">Arızalı</option>
                      <option value="stock">Stokta</option>
                    </select>   
                  </div>

                  <div className="inventory-form-group">
                    <label>Alış Tarihi</label>
                    <input
                      type="date"
                      value={editingItem.purchase_date || ''}
                      onChange={(e) => setEditingItem({...editingItem, purchase_date: e.target.value})}
                    />
                  </div>

                  <div className="inventory-form-group">
                    <label>Garanti Bitiş Tarihi</label>
                    <input
                      type="date"
                      value={editingItem.warranty_end_date || ''}
                      onChange={(e) => setEditingItem({...editingItem, warranty_end_date: e.target.value})}
                    />
                  </div>

                  {/* Notlar - Full width */}
                  <div className="inventory-form-group inventory-form-full-width">
                    <label>Bilgisayar Özellikleri</label>
                    <textarea
                      placeholder="İşlemci, RAM, disk, ekran kartı vb."
                      value={editingItem.computer_specs || ''}
                      onChange={(e) => setEditingItem({...editingItem, computer_specs: e.target.value})}
                      rows="3"
                    />
                  </div>

                  <div className="inventory-form-group inventory-form-full-width">
                    <label>Notlar</label>
                    <textarea
                      value={editingItem.notes || ''}
                      onChange={(e) => setEditingItem({...editingItem, notes: e.target.value})}
                      rows="3"
                    />
                  </div>
                </div>
              </div>

              <div className="inventory-modal-footer">
                <button type="submit" className="inventory-btn-primary">
                  Güncelle
                </button>
                <button
                  type="button"
                  onClick={() => setEditingItem(null)}
                  className="inventory-btn-secondary"
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Message Display */}
      {message && (
        <div className={`inventory-message ${message.includes('başarı') ? 'inventory-success' : 'inventory-error'}`}>
          {message}
        </div>
      )}

      {/* Inventory Table */}
      <div className="admin-inventory-table-container">
        {safeInventory.length === 0 ? (
          <div className="inventory-no-data">Filtreye uygun ürün bulunamadı.</div>
        ) : (
          <table className="admin-inventory-table">
            <thead>
              <tr>
                <th>
                  Ürün Adı
                  {sortBy === 'product_name' && (
                    <span className="sort-indicator">{sortOrder === 'asc' ? ' ↑' : ' ↓'}</span>
                  )}
                </th>
                <th>
                  Ürün Kodu
                  {sortBy === 'product_code' && (
                    <span className="sort-indicator">{sortOrder === 'asc' ? ' ↑' : ' ↓'}</span>
                  )}
                </th>
                <th>
                  Kategori
                  {sortBy === 'category' && (
                    <span className="sort-indicator">{sortOrder === 'asc' ? ' ↑' : ' ↓'}</span>
                  )}
                </th>
                <th>Atanan Kullanıcı</th>
                <th>Lokasyon</th>
                <th>
                  Durum
                  {sortBy === 'status' && (
                    <span className="sort-indicator">{sortOrder === 'asc' ? ' ↑' : ' ↓'}</span>
                  )}
                </th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {safeInventory.map((item, index) => (
                <tr key={item.id} className={`inventory-table-row ${index % 2 === 0 ? 'inventory-even' : 'inventory-odd'}`}>
                  <td className="inventory-item-name">
                    <div className="inventory-name-cell">
                      <span className="inventory-product-name">{item.product_name}</span>
                    </div>
                  </td>
                  <td className="inventory-item-code">{item.product_code}</td>
                  <td className="inventory-item-category">{item.category_name || 'Belirtilmemiş'}</td>
                  <td className="inventory-item-user">
                    {getFullNameByEmail(item.assigned_user_email, users) || 'Atanmadı'}
                  </td>
                  <td className="inventory-item-location">{item.location || 'Belirtilmemiş'}</td>
                  <td className="inventory-item-status">
                    <span className={`inventory-status-badge inventory-status-${item.status || 'active'}`}>
                      {getStatusLabel(item.status)}
                    </span>
                  </td>
                  <td className="inventory-item-actions">
                    <div className="inventory-action-buttons">
                      <button
                        onClick={() => setViewingItem(item)}
                        className="inventory-btn-details"
                        title="Detaylar"
                      >
                        Detay
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminInventory;